import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Folder from './icon-folder.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Folder {...validProps} />;
}
SvgComponent.iconName = 'folder';

export const FolderIcon = svgIconWrapper(SvgComponent);
